module.exports = __webpack_public_path__ + "img/nl-flag.5a5c4cf3.png";